const currentYear = new Date().getFullYear();
const tag = document.querySelector('.js-copyright-year');
tag.innerHTML = `Copyright &copy; ${currentYear}`;
